/**
 * Merke, modell og produktlenke ved registrering og i «Hent produktdata» (VIB-2936).
 * Lenken sjekkes her for å gi feilmelding i skjemaet; equipment-enrich sjekker
 * den på nytt med isSafePublicUrl før siden hentes.
 */

const INTERNAL_SUFFIXES = [".localhost", ".local", ".internal", ".lan", ".corp", ".home", ".intranet", ".private"];

/** Tom streng gir null. Ellers en offentlig http(s)-adresse, eller en feilmelding. */
export function parseProductUrl(raw: string): { url: string | null } | { error: string } {
  const value = raw.trim();
  if (!value) return { url: null };
  let u: URL;
  try {
    u = new URL(value);
  } catch {
    return { error: "Produktlenken må være en hel adresse, f.eks. https://www.sony.com/…" };
  }
  const host = u.hostname.toLowerCase().replace(/\.+$/, "");
  const ipLike = /^[\d.]+$/.test(host) || host.includes(":") || host.startsWith("[");
  if (
    (u.protocol !== "http:" && u.protocol !== "https:") ||
    u.username ||
    u.password ||
    !host.includes(".") ||
    ipLike ||
    host === "localhost" ||
    INTERNAL_SUFFIXES.some((s) => host.endsWith(s))
  ) {
    return { error: "Produktlenken må være en offentlig nettadresse som begynner med https://" };
  }
  return { url: u.toString() };
}

export interface ProductFields {
  brand: string;
  model: string;
  productUrl: string;
}

export interface ProductLink {
  brand: string;
  model: string;
  productUrl: string | null;
}

/** Merke og modell hører sammen, og en lenke krever begge. Alle tomme gir `link: null`. */
export function checkProductFields(f: ProductFields): { link: ProductLink | null } | { error: string } {
  const brand = f.brand.trim();
  const model = f.model.trim();
  const parsed = parseProductUrl(f.productUrl);
  if ("error" in parsed) return parsed;
  if (!brand && !model && !parsed.url) return { link: null };
  if (!brand || !model) {
    return { error: parsed.url ? "Fyll ut merke og modell når du legger inn produktlenke" : "Fyll ut både merke og modell" };
  }
  return { link: { brand, model, productUrl: parsed.url } };
}
